import store from '@/store'

export function setToken(token) {
  let tokenObj = token.substr(token.indexOf('&')+1).split("&");
  let tokenMap = {};
  for (var i in tokenObj) {
    let tokenItem = tokenObj[i].split("=");
    tokenMap[tokenItem[0]] = tokenItem[1];
    localStorage[tokenItem[0]] = tokenItem[1];
  }
  let accessToken = store.getters.objApi.LOCAL_URL.substr(store.getters.objApi.LOCAL_URL.indexOf("://") + 3);
  localStorage[accessToken] = JSON.stringify(tokenMap);
  window.location.href = store.getters.objApi.LOCAL_URL;
}

export function getToken() {
  let token = localStorage.getItem(store.getters.objApi.LOCAL_URL.substr(store.getters.objApi.LOCAL_URL.indexOf("://") + 3));
  if (token) {
    return JSON.parse(token);
  } else if (localStorage.access_token && localStorage.token_type) {
    let {access_token, token_type} = localStorage;
    return { access_token, token_type };
  }else {
    return null;
  }

}

export function clearToken() {
  return new Promise((reslove, reject) => {
    if (localStorage.isRember) {
      let remberLogin = localStorage.isRember;
      sessionStorage.clear();
      localStorage.clear();
      localStorage.isRember = remberLogin;
      reslove();
    } else {
      sessionStorage.clear();
      localStorage.clear();
      reslove();
    }
  }).catch(error => {
    reject(error);
  })

}



// WEBPACK FOOTER //
// ./src/utils/auth.js